import { Vue } from 'vue-property-decorator'
import { GQLConfig } from '~/graphql/__generated__/interfaces'

const webComponentsConfig = ({
  currency,
  decimalsSeparator,
  thousandSeparator,
  priceRound,
  nxtFormatDateShort,
  nxtFormatDateLong,
}: GQLConfig['shopConfig']) => {
  const formatDate = {
    long: nxtFormatDateLong,
    short: nxtFormatDateShort,
  }

  Vue.prototype.$webComponentsConfiguration = {
    ...Vue.prototype.$webComponentsConfiguration,
    formatDate,
    currencyConfig: {
      currency,
      decimals: priceRound,
      decimalSeparator: decimalsSeparator,
      thousandSeparator,
    },
  }
}

export default webComponentsConfig
